import { axiosInstance } from ".";

const getTrips = async (params) =>
  await axiosInstance.get("/trips", { params });

const getTripDetails = async (id) => await axiosInstance.get(`/trips/${id}`);

const forceEndTrip = async (id) =>
  await axiosInstance.patch(`/trips/${id}/force_end`);

export { getTrips, getTripDetails, forceEndTrip };
